/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Templates_Settings_Contact_Show_Wrap_Up_TimeInputs */

const en_forms_templates_settings_contact_show_wrap_up_time = /** @type {(inputs: Forms_Templates_Settings_Contact_Show_Wrap_Up_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

const de_forms_templates_settings_contact_show_wrap_up_time = /** @type {(inputs: Forms_Templates_Settings_Contact_Show_Wrap_Up_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

/**
* | output |
* | --- |
* | "Time" |
*
* @param {Forms_Templates_Settings_Contact_Show_Wrap_Up_TimeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_templates_settings_contact_show_wrap_up_time = /** @type {((inputs?: Forms_Templates_Settings_Contact_Show_Wrap_Up_TimeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Templates_Settings_Contact_Show_Wrap_Up_TimeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_templates_settings_contact_show_wrap_up_time(inputs)
	return de_forms_templates_settings_contact_show_wrap_up_time(inputs)
});